import React from 'react';
import { X } from 'lucide-react';
import { useInfraestruturaData } from '../context/InfraestruturaDataContext';

const InfraestruturaFilterChips = () => {
  const { filters, removeFilter, clearFilters } = useInfraestruturaData();

  if (!Array.isArray(filters) || filters.length === 0) {
    return null;
  }

  return (
    <div className="mb-3 flex flex-wrap items-center gap-2 rounded-[14px] border border-[color:var(--border)] bg-[color:var(--surface)] px-3 py-2 shadow-[0_10px_24px_rgba(15,23,42,0.08)]">
      <span className="text-xs font-semibold uppercase tracking-[0.12em] text-[color:var(--text-muted)]">
        Filtros ativos
      </span>

      <div className="flex flex-wrap items-center gap-2">
        {filters.map((filter) => (
          <button
            key={`${filter.field}:${String(filter.value ?? 'null')}`}
            type="button"
            onClick={() => removeFilter(filter)}
            className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--border)] bg-[color:var(--surface-muted)] px-3 py-1 text-xs font-medium text-[color:var(--text-primary)] transition-colors hover:border-[color:var(--accent)]/60 hover:text-[color:var(--accent)]"
            aria-label={`Remover filtro ${filter.label}`}
          >
            <span className="max-w-[260px] truncate">{filter.label}</span>
            <X className="h-3.5 w-3.5 text-[color:var(--text-muted)]" />
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={clearFilters}
        className="ml-auto rounded-[8px] border border-[color:var(--border)] px-3 py-1.5 text-xs font-medium text-[color:var(--text-muted)] transition-colors hover:text-[color:var(--text-primary)]"
      >
        Limpar filtros
      </button>
    </div>
  );
};

export default InfraestruturaFilterChips;
